module.exports = __webpack_public_path__ + "img/china-sinopec-logo.a031b627.png";